import { Row } from '@sdbn/common';
import { ColumnType } from '@sdbn/common';
import { SelectionType } from '@sdbn/common';
import { TmcTableModel } from '@sdbn/common';
import { TransportAttachDetachService } from './../../service/transport-attach-detach.service';
import { AttachDetachStepperModel } from '../../model/attach-detach-step-model';
import { Component, OnInit } from '@angular/core';
import { TruckDetails } from '../../model/visit-details';
import { TransportAttachDetachStepperService } from '../../service/transport-attach-detach-stepper.service';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { TMCClientParameters } from '@sdbn/tmc-common';
import { AppClientConfigurationService } from '@sdbn/common';

@Component({
    selector: 'app-attach-truck',
    templateUrl: './attach-truck.component.html',
    styleUrls: ['./attach-truck.component.scss'],
    standalone: false
})
export class AttachTruckComponent implements OnInit {

  detailsFormGroup = new FormGroup({});

  selectedDetails: TruckDetails;

  stepperModel: AttachDetachStepperModel;

  tableModel: TmcTableModel = new TmcTableModel();

  useAsServiceTruckManuallySelected = false;

  clientParameters = TMCClientParameters;

  serviceVehiclesEnabled = false;

  constructor(
    private tsmService: TransportAttachDetachService,
    public cps: AppClientConfigurationService,
    private stepperService: TransportAttachDetachStepperService
  ) {

    this.detailsFormGroup.addControl('useAsServiceTruck', new FormControl(false, []));
    this.detailsFormGroup.valueChanges.subscribe(
      value => {
        if (this.detailsFormGroup.dirty && this.selectedDetails != null) {
          this.useAsServiceTruckManuallySelected = this.detailsFormGroup.controls.useAsServiceTruck.value;
          this.stepperModel.workingData.useAsServiceTruck = this.useAsServiceTruckManuallySelected || this.selectedDetails.isServiceTruck;
        }
      }
    );

    this.stepperModel = this.stepperService.stepperModel;

    this.tableModel.selectionType = SelectionType.SINGLE;
    this.tableModel.sortable = false;
    this.tableModel.filterable = false;

    const prefix = 'tmc-yard.ui.transport.attach-detach.dialog.table.trucks.column.';
    this.tableModel.columnDefinitions = [
      { id: 'driver', name: 'driver', visible: true, type: ColumnType.STRING, translationKey: prefix + 'driver' },
      { id: 'coDriver', name: 'coDriver', visible: true, type: ColumnType.STRING, translationKey: prefix + 'coDriver' },
      { id: 'carrier', name: 'carrier', visible: true, type: ColumnType.STRING, translationKey: prefix + 'carrier' },
      { id: 'supplier', name: 'supplier', visible: true, type: ColumnType.STRING, translationKey: prefix + 'supplier' },
      { id: 'numberPlate', name: 'numberPlate', visible: true, type: ColumnType.STRING, translationKey: prefix + 'numberPlate' },
      { id: 'registration', name: 'registration', visible: true, type: ColumnType.STRING, translationKey: prefix + 'registration' },
      {
        id: 'registrationSortValue', name: 'registrationSortValue',
        visible: false, type: ColumnType.STRING, translationKey: prefix + 'registrationSortValue'
      },
    ];

    // hook to enable/disable next button
    this.stepperModel.stepCompleted = () => {
      return this.tableModel.selectedRows.length === 1;
    };

    this.stepperModel.getNextStepIndex = () => {
      return 0;
    };

    this.stepperModel.getPreviousStepIndex = () => {
      return 0;
    };

    this.stepperModel.beforeNextStep = () => {
      return true;
    };

    if (this.cps.isPropertyTrue(this.clientParameters.FEATURES_SERVICE_VEHICLE, false)) {
      this.serviceVehiclesEnabled = true;
    }

  }

  ngOnInit() {
    this.tsmService.getCurrentVisits().subscribe(result => {
      this.tableModel.setRows(this.convertToTableRows(result));
    }, error => {
      console.log('Error loading current visits', error);
    });
  }

  private convertToTableRows(details: TruckDetails[]): Row[] {
    const rows: Row[] = [];
    for (const w of details) {
      const row: Row = new Row();
      row.id = w.truckId + '';
      row.values = {
        id: w.truckId,
        numberPlate: w.numberPlate,
        driver: w.driver,
        coDriver: w.coDriver,
        carrier: w.carrier,
        supplier: w.supplier,
        registration: w.registration,
        registrationSortValue: w.registrationSortValue,
        truckDetails: w
      };
      rows.push(row);
    }
    return rows;
  }

  onSelectionChanged(rows: Row[]) {
    if (rows && rows.length === 1) {
      this.stepperModel.workingData.truckId = + rows[0].id;
      this.selectedDetails = rows[0].values.truckDetails;
      this.stepperModel.workingData.useAsServiceTruck = this.useAsServiceTruckManuallySelected || this.selectedDetails.isServiceTruck;
    } else {
      this.stepperModel.workingData.truckId = null;
      this.stepperModel.workingData.useAsServiceTruck = false;
      this.selectedDetails = null;
    }


    this.detailsFormGroup.reset({
      useAsServiceTruck: this.useAsServiceTruckManuallySelected || this.selectedDetails?.isServiceTruck
    });

    if (this.selectedDetails != null && !this.selectedDetails.isServiceTruck) {
      this.detailsFormGroup.controls.useAsServiceTruck.enable({ onlySelf: false, emitEvent: false });
    } else {
      this.detailsFormGroup.controls.useAsServiceTruck.disable({ onlySelf: false, emitEvent: false });
    }
  }

}
